// Native client token transport restored from feature/ios-capacitor.
// Client tokens stay in this device's Keychain, separate for each Clerk instance.
const nativeClerkLoads = new Map();

export function loadNativeClerk(publishableKey) {
  if (nativeClerkLoads.has(publishableKey)) {
    return nativeClerkLoads.get(publishableKey);
  }

  const loading = (async () => {
    const [{ Clerk }, { SecureStorage, KeychainAccess }] = await Promise.all([
      import("@clerk/clerk-js"),
      import("@aparajita/capacitor-secure-storage"),
    ]);

    const storageKey = "frontrow.clerk.client.v1:" + publishableKey;
    const saved = await SecureStorage.get(storageKey, false, false);
    let clientToken = typeof saved === "string" ? saved : "";
    let storageWrites = Promise.resolve();

    const clerk = new Clerk(publishableKey);

    clerk.__unstable__onBeforeRequest(request => {
      request.credentials = "omit";
      request.url?.searchParams.set("_is_native", "1");
      if (clientToken) {
        request.headers.set("Authorization", clientToken);
      }
    });

    clerk.__unstable__onAfterResponse(async (request, response) => {
      const token = response?.headers.get("Authorization");
      if (!token) return;

      clientToken = token;
      const write = storageWrites.catch(() => {}).then(() =>
        SecureStorage.set(
          storageKey,
          token,
          false,
          false,
          KeychainAccess.whenUnlockedThisDeviceOnly
        )
      );
      storageWrites = write;
      await write;
    });

    await clerk.load({ standardBrowser: false });
    if (!clerk.loaded) {
      throw new Error("Native Clerk did not finish loading.");
    }
    await storageWrites;
    return clerk;
  })();

  nativeClerkLoads.set(publishableKey, loading);
  loading.catch(() => {
    if (nativeClerkLoads.get(publishableKey) === loading) {
      nativeClerkLoads.delete(publishableKey);
    }
  });
  return loading;
}

